<template>
  <div class="section">
    <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
      <div class="columns">
        <div class="column is-8-tablet is-offset-2-tablet">
          <div class="block mb-6">
            <div class="columns">
              <div class="column set-height">
                <h4 class="title is-3">Profile</h4>
              </div>
            </div>
            <div class="box">
              <div class="block">
                <BInputWithValidation
                  rules="required|max:100"
                  type="text"
                  label="Organisation"
                  v-model="org.name"
                />
              </div>
              <div class="columns">
                <div class="column">
                  <BInputWithValidation
                    rules="max:50"
                    type="text"
                    label="Straße"
                    v-model="org.street"
                  />
                </div>
                <div class="column is-3">
                  <BInputWithValidation
                    rules=""
                    type="number"
                    label="Nr."
                    v-model="org.house_no"
                  />
                  <!-- max:5 -->
                </div>
                <div class="column is-3">
                  <BInputWithValidation
                    rules="max:50"
                    type="text"
                    label="Zusatz"
                    v-model="org.street_additional"
                  />
                </div>
              </div>
              <div class="columns">
                <div class="column is-3">
                  <BInputWithValidation
                    rules="min:5|max:50"
                    type="text"
                    label="PLZ"
                    v-model="org.zip_code"
                  />
                </div>
                <div class="column">
                  <BInputWithValidation
                    rules="max:30"
                    type="text"
                    label="Stadt"
                    v-model="org.city"
                  />
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <BInputWithValidation
                    rules="max:500"
                    type="textarea"
                    label="Notiz"
                    v-model="org.comment"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="block">
            <div class="columns">
              <div class="column set-height">
                <h4 class="title is-3">Berechtigungen</h4>
              </div>
            </div>
            <div class="box">
              <div class="columns is-multiline">
                <div class="column is-half">
                  <b-field>
                    <BSelectWithValidation
                      label="Lizenz Typ"
                      v-model="org.license_type"
                      expanded
                    >
                      <!-- rules="include:main,sub" -->
                      <option value="main">Hauptlizenz</option>
                      <option value="sub">Unterlizenz</option>
                    </BSelectWithValidation>
                  </b-field>
                  <b-field>
                    <b-checkbox v-model="org.test">
                      Lizenz ist Test Version
                    </b-checkbox>
                  </b-field>
                </div>
                <div v-if="org.license_type === 'sub'" class="column is-half">
                  <BSelectWithValidation
                    label="Zugehörig zu"
                    v-model="org.main_license_org_id"
                    expanded
                  >
                    <template v-for="orgMain in orgsWithMainLicence">
                      <option :key="orgMain.id" :value="orgMain.id">
                        {{ orgMain.name }}
                      </option>
                    </template>
                  </BSelectWithValidation>
                </div>
                <div class="column is-half">
                  <BInputWithValidation
                    type="text"
                    label="Lizenz-Nr."
                    v-model="org.license_no"
                  />
                </div>
              </div>
              <div class="columns">
                <div v-if="org.expires_at !== null" class="column is-half">
                  <b-field label="Laufzeit">
                    <b-datepicker
                      v-model="expiresAt"
                      :min-date="new Date()"
                      placeholder="Click to select..."
                      icon="calendar-day"
                      trap-focus
                    >
                    </b-datepicker>
                  </b-field>
                  <b-field v-if="!org.test">
                    <b-checkbox v-model="org.contract_renews">
                      Vertrag verlängert sich
                    </b-checkbox>
                  </b-field>
                </div>
                <div class="column is-half">
                  <b-field>
                    <BSelectWithValidation
                      label="Zugehörig zu"
                      v-model="org.tableau_user_id"
                      expanded
                    >
                      <template v-for="tableauUser in tableauUsers">
                        <option :key="tableauUser.id" :value="tableauUser.id">
                          {{ tableauUser.name }}
                        </option>
                      </template>
                    </BSelectWithValidation>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-6 is-offset-3">
              <b-button
                type="is-gold"
                :disabled="invalid"
                @click="handleSubmit(submit)"
                expanded
              >
                Organisation erstellen
              </b-button>
            </div>
          </div>
          <div class="block" v-if="error">
            <b-message type="is-danger">
              <span v-html="error" />
            </b-message>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import helper from '@/functions/helper';
import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';
import BSelectWithValidation from '@/components/inputs/BSelectWithValidation.vue';

export default {
  name: 'NewOrg',
  components: {
    BInputWithValidation,
    BSelectWithValidation,
  },
  data() {
    return {
      org: {
        name: '',
        test: false,
        expires_at: new Date().getTime(),
        license_type: 'main',
        user_amount: 3,
        street: '',
        house_no: '',
        street_additional: '',
        city: '',
        zip_code: '',
        country: 'Germany',
        main_license_org_id: null,
        comment: '',
        license_no: null,
        contract_renews: true,
        tableau_user_id: 1,
      },
    };
  },
  computed: {
    orgsWithMainLicence() {
      return this.orgs.filter((item) => item.license_type === 'main');
    },
    ...mapGetters({
      orgs: 'org/data',
      error: 'org/error',
      tableauUsers: 'tableau/data',
    }),
    expiresAt: {
      get() {
        return new Date(this.org.expires_at);
      },
      set(val) {
        this.org.expires_at = helper.dateToTime(val);
      },
    },
  },
  methods: {
    submit() {
      const toSubmit = this.org;

      if (toSubmit.license_no === '' || toSubmit.license_no === null) {
        toSubmit.license_no = null;
      } else {
        toSubmit.license_no = Number(toSubmit.license_no);
      }

      if (toSubmit.license_type === 'admin') delete toSubmit.expires_at;

      if (toSubmit.test) {
        toSubmit.contract_renews = false;
      }

      if (toSubmit.license_type === 'main') delete toSubmit.main_license_org_id;
      // toSubmit.expires_at = helper.dateToTime(toSubmit.expires_at);

      this.$store.dispatch('org/CREATE', toSubmit);
    },
  },
};
</script>

<style lang="scss" scoped>
.is-inactive {
  color: rgb(184, 184, 184);
  &:hover {
    color: hsl(0, 0%, 62%);
  }
}
</style>
